<template>
	<div class="summary">
		<div v-for="section in sections" :key="section.key"
			class="questions">
			<template v-if="Array.isArray(appointment[section.key])">
				<h5><img :src="getImage(section.image)"> {{ section.title }}</h5>
				<div v-for="question in appointment[section.key]" :key="question" class="question">
				{{ question }}
			</div>
			</template>
		</div>
	</div>
</template>
<script>
import sections from './sections'

export default {
	name: 'appointment-summary',

	props: {
		appointment: {
			type: Object,
			required: true
		}
	},

	data() {
		return {
			sections
		}
	},

	methods: {
		getImage(image) {
			return require('./image/' + image)
		}
	}
}

</script>

<style lang="scss" scoped>
.summary {
	padding: 5px 0 15px 0;
}
.questions {
	h5 {
		font-size: 14px;
		line-height: 24px;
		padding: 5px 15px 0 15px;

		img {
			width: 24px;
			height: 24px;
			margin-left: 10px;
			margin-right: 10px;
			float: left;
		}
	}
	.question {
		padding: 2px 15px 2px 60px;
		font-size: 14px;
		line-height: 18px;
	}
}

</style>
